/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 6.1.6
* 
*******************************************************************************/
import React from 'react';
import T from 'prop-types';
import { withFocus } from '@accedo/vdkweb-navigation';

/**
 * Focus Div is a simple HTML `<div>` element with the knowledge of spatial
 * navigation by wrapping a styleable `<div>` element with the withFocus high-order
 * function from `@accedo/vdkweb-navigation`.
 *
 * The major use case is to receive the nav property object from the parent,
 * modify the properties when necessary, and pass it on to the children element(s)
 * if needed.
 *
 * @returns {React.ReactElement} The FocusDiv Element
 */
export var FocusDivComponent = function FocusDivComponent(_ref) {
  var style = _ref.style,
    className = _ref.className,
    children = _ref.children,
    dir = _ref.dir;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    dir: dir,
    style: style
  }, children);
};
FocusDivComponent.defaultProps = {
  className: '',
  style: {}
};
FocusDivComponent.propTypes = {
  /** React's special prop, children. */
  children: T.node.isRequired,
  /** Class name that will be applied to the `<div>` element. */
  className: T.string,
  /** Dir attribute specifies the text direction of the element's content. Acceptable values can be checked [here](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir) */
  dir: T.string,
  /** React style attribute object, which will be applied to the `<div>` element. */
  style: T.object
};
export default withFocus(FocusDivComponent);